import { FunctionComponent } from 'react'
import { ChefRowCard as ChefRowCardProps } from './ChefRowCard.types'
import { CollectionCard } from '../CollectionCard/CollectionCard'

export const ChefRowCard: FunctionComponent<ChefRowCardProps> = ({
  attributes
}) => {
  return (
    <CollectionCard
      title={attributes.name}
      image={attributes.image}
      actions={attributes.actions}
      tag={attributes.speciality}
      rating={attributes.rating}
    />
  )
}
